import Reveal from "../components/Reveal";

export default function Terms() {
  return (
    <div>
      <section className="pt-40 md:pt-48 pb-12 container-luxe">
        <div className="eyebrow mb-6">Terms & Conditions</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">The fine print, <span className="italic">finely written</span>.</h1>
        <p className="mt-6 text-foreground/55 text-sm">Last updated: February 2026</p>
      </section>

      <section className="container-luxe pb-24 max-w-3xl">
        <Reveal>
          <article className="space-y-10 text-foreground/80 leading-[1.85]">
            <div>
              <h2 className="font-serif text-3xl mb-4">1. Acceptance of Terms</h2>
              <p>By engaging Voyage Luxe Travel Atelier, you accept these terms in their entirety. Each journey is also accompanied by a private booking agreement with destination-specific terms which take precedence.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">2. Booking & Deposits</h2>
              <p>A 30% non-refundable deposit is required to confirm any journey. The balance is due 60 days prior to departure. Bespoke itineraries may have additional supplier deposit requirements which will be detailed in your private booking agreement.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">3. Cancellation</h2>
              <p>Cancellations more than 90 days from departure: 70% refund (deposit retained). 60–90 days: 50% refund. 30–60 days: 25% refund. Inside 30 days: no refund. We strongly recommend comprehensive travel insurance.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">4. Travel Insurance</h2>
              <p>Comprehensive travel and medical insurance is mandatory for all Voyage Luxe journeys. We can recommend trusted providers but the responsibility for procurement rests with the guest.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">5. Force Majeure</h2>
              <p>Voyage Luxe is not liable for delays, cancellations, or losses caused by acts beyond reasonable control, including weather, civil unrest, or supplier insolvency. We work tirelessly to provide alternatives or reschedule when such events occur.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">6. Governing Law</h2>
              <p>These terms are governed by the laws of India. Any dispute shall be subject to the exclusive jurisdiction of the courts of New Delhi.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">7. Contact</h2>
              <p>Questions? Write to <a className="text-accent" href="mailto:concierge@voyageluxe.com">concierge@voyageluxe.com</a>.</p>
            </div>
          </article>
        </Reveal>
      </section>
    </div>
  );
}
